export const en = {
  title: 'Cookie Consent',
  description:
    "We use Microsoft Clarity to understand better how people use our software. By allowing this cookie, we can improve your and other's experience. All data from Clarity is anonymized. Learn more in our",
  cookiePolicyLabel: 'Privacy Policy',
  acceptAllLabel: 'Accept',
  declineLabel: 'Decline',
  revokeMessage: 'You can change this anytime from account preferences',
  closeLabel: 'Close and decline',
}

export const es = en
